import {
  DEFAULT_PRESCRIPTION_TYPE,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'

export const getDefaultPrescriptionType = template => {
  switch (template) {
    case PRODUCT_TEMPLATES.RX:
      return DEFAULT_PRESCRIPTION_TYPE[PRODUCT_TEMPLATES.RX]
    case PRODUCT_TEMPLATES.OTX:
      return DEFAULT_PRESCRIPTION_TYPE[PRODUCT_TEMPLATES.OTX]
    case PRODUCT_TEMPLATES.OTC:
    default:
      return DEFAULT_PRESCRIPTION_TYPE[PRODUCT_TEMPLATES.OTC]
  }
}
